/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from "react";
import { wrap } from "comlink";
import { useTranslation } from "react-i18next";
import PagePaymentService from '../../../../services/pagePaymentService';
import { useCompany } from '../../../../provider/companyProvider';

const worker = new Worker(new URL("./pdfOnePagePaymentWorker.js", import.meta.url));
const workerApi = wrap(worker);

const usePdfPagePayment = () => {
  const { t, i18n } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const { business } = useCompany();

  const pdfPayment = async (id) => {

    if (!id) return;
    setIsLoading(true);

    try {
      // Fetch payment data
      const data = await PagePaymentService.fetchOne(id);
      const pagePayment = JSON.parse(JSON.stringify(data)); // clone safely

      // Pass everything to the worker
      const blobUrl = await workerApi.renderPDF({
        pagePayment,
        business,
        language: i18n.language,
        t: {
          pagePaymentInfo: t("pagePaymentInfo"),
          id: t("id"),
          pageName: t("pageName"),
          priceAmount: t("priceAmount"),
          note: t("note"),
          branch: t("branch"),
          user: t("user"),
          createdAt: t("createdAt"),
          currentDate: t("currentDate"),
          number: t("number"),
          invoiceNumber: t("invoiceNumber"),
          receiverPhone: t("receiverPhone"),
          address: t("address"),
          totalPrice: t("totalPrice"),
          transportationPrice: t("transportationPrice"),
          netPrice: t("netPrice"),
          date: t("date"),
          totalItems: t("totalItems"),
          totalPostAmount: t("totalPostAmount"),
          totalTransportationAmount: t("totalTransportationAmount"),
          netPostAmount: t("netPostAmount"),
        },
      });

      // Open PDF
      window.open(blobUrl);
    } catch (error) {
      console.error("Error generating PDF in worker:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, pdfPayment };
};

export default usePdfPagePayment;
